import useAppStore from "@/context/store";
import { gdOssUrl } from "@/utils/imageUrl";
import { Button } from "antd";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useCallback, useMemo, useState } from "react";
import { Case, Switch } from "react-if";
import HBModal from "../../HBModal";
import PayResult from "../payResult";
import { useDialogContext, VipDialogContext } from "../shared/configContext";
import VipHeader from "../shared/header3";
import PublicTransfer from "../Transfer";
import styles from "./index.module.less";
import PkgDetail from "./pkgDetail";

const Step = {
  BuyPage: "buyPage",
  Transfer: "transfer",
  PayResult: "payResult",
};

/**
 * 增加授权主体
 */
export default function AddSubjectCert({
  userRight,
  selectedPkg,
  onOk,
  onCancel,
  onPaid,
  onFinish,
  onAborted,
  ...props
}) {
  const user = useAppStore((s) => s.user);
  // 权益信息
  const context = useDialogContext(userRight);
  const { rightData } = context;
  const router = useRouter();

  // 步骤
  const [step, setStep] = useState(Step.BuyPage);

  const [order, setOrder] = useState({});

  const onOrderDone = useCallback(
    (order) => {
      onPaid && onPaid(order);
      setOrder(order);
      setStep(Step.PayResult);
    },
    [onPaid]
  );

  const wrapStyle = useMemo(() => {
    return {
      width: 960,
      overflow: "hidden",
      backgroundImage: `url(${gdOssUrl(
        "https://st0.dancf.com/static/02/202202110238-4e8a.jpg",
        {
          width: 960,
        }
      )})`,
      backgroundSize: "cover",
    };
  }, []);

  // 取消弹框
  const onCancelWrap = useCallback(() => {
    if (step === Step.PayResult) {
      onOk && onOk();
    } else {
      onCancel && onCancel(step);
    }
    // 不在前两步，调用 onFinish
    if (step !== Step.BuyPage && step !== Step.Transfer) {
      onFinish && onFinish(order);
    } else {
      // 终止
      onAborted && onAborted(step);
    }
  }, [onCancel, step, onOk, onFinish, order, onAborted]);

  const [transferProps, setTransferProps] = useState({});
  const onTransfer = useCallback((transferProps) => {
    setStep(Step.Transfer);
    setTransferProps(transferProps);
  }, []);

  const onCancelTransfer = useCallback(() => {
    setStep(Step.BuyPage);
  }, []);

  if (!rightData) {
    return null;
  }

  return (
    <VipDialogContext.Provider value={context}>
      <HBModal
        className={classNames(styles.dialog, {
          [styles.step1]: step === Step.BuyPage,
        })}
        {...props}
        width={960}
        footer={null}
        bodyStyle={{ padding: 0, overflowX: "auto" }}
        onCancel={onCancelWrap}
      >
        <div style={wrapStyle}>
          {[Step.BuyPage, Step.Transfer].includes(step) && (
            <VipHeader user={user} onCancel={onCancelWrap} />
          )}

          <Switch>
            <Case condition={step === Step.BuyPage}>
              <div key={step} style={{ marginTop: 90 }}>
                <PkgDetail
                  defaultSelectedPkg={selectedPkg}
                  onOrderDone={onOrderDone}
                  onTransfer={onTransfer}
                />
              </div>
            </Case>
            {/* 对公转账 */}
            <Case condition={step === Step.Transfer}>
              <PublicTransfer
                {...transferProps}
                onCancelTransfer={onCancelTransfer}
              />
            </Case>
            <Case condition={step === Step.PayResult}>
              <PayResult
                key={step}
                title="购买成功"
                show={false}
                order={order}
                style={{ height: 772 }}
                bottom={
                  <div style={{ textAlign: "center", marginTop: 24 }}>
                    <Button
                      size="large"
                      type="primary"
                      onClick={() => {
                        onCancelWrap();
                        router.push("/me/subject");
                      }}
                    >
                      去填写授权书
                    </Button>
                  </div>
                }
              />
            </Case>
          </Switch>
        </div>
      </HBModal>
    </VipDialogContext.Provider>
  );
}
